__turbopack_context__.v({
  "className": "space_grotesk_2de40e4a-module__WWmnGa__className",
  "variable": "space_grotesk_2de40e4a-module__WWmnGa__variable",
});
